import { useState } from 'react';
import { SiLinkedin } from 'react-icons/si';
import { Mail, Check } from 'lucide-react';
import uniImage from '../Assets/icon2.png';

export default function Footer() {
  const [ copied, setCopied ] = useState(false);
  const [ showToast, setShowToast ] = useState(false);

  const email = "contact@unilinkd.com";

  const handleCopyEmail = async () => {
    let success = false;

    try {
      // ✅ Modern clipboard API (works on secure contexts)
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(email);
        success = true;
      } else {
        throw new Error("Clipboard API not available");
      }
    } catch {
      // ✅ Fallback for mobile / older browsers
      const textArea = document.createElement("textarea");
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        success = document.execCommand("copy");
      } catch (err) {
        console.error("Fallback copy failed", err);
      }

      document.body.removeChild(textArea);
    }

    if (success) {
      setCopied(true);
      setShowToast(true);

      setTimeout(() => {
        setCopied(false);
        setShowToast(false);
      }, 2000);
    }
  };

  const openLinkedIn = () => {
    window.open(
      'https://www.linkedin.com/company/unilinkd/?viewAsMember=true',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <footer className="bg-brand-white shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-3">

          {/* Brand Column */}
          <div>
            <img
              src={uniImage}
              alt="UNILinkd Logo"
              className="mb-4 h-12 w-auto"
            />
            <p className="text-sm font-medium text-brand-black">
              Bridging offline-to-digital education for a connected learning experience.
            </p>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="mb-4 text-sm font-bold text-brand-black">Quick Links</h3>
            <ul className="space-y-2 text-sm font-medium text-brand-black">
              <li><a href="/" className="transition-colors hover:text-brand-blue">Home</a></li>
              <li><a href="/about" className="transition-colors hover:text-brand-blue">About</a></li>
              <li><a href="/services" className="transition-colors hover:text-brand-blue">Services</a></li>
              <li><a href="/download" className="transition-colors hover:text-brand-blue">Download</a></li>
              <li><a href="/privacy" className="transition-colors hover:text-brand-blue">Privacy Policy</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="mb-4 text-sm font-bold text-brand-black">Connect With Us</h3>

            <div className="flex flex-col space-y-4">

              {/* LinkedIn */}
              <button
                onClick={openLinkedIn}
                className="flex items-center gap-3 text-brand-black transition-all hover:text-brand-blue"
              >
                <SiLinkedin className="h-5 w-5" />
                <span className="text-sm font-medium">LinkedIn</span>
              </button>

              {/* Email Copy */}
              <button
                onClick={handleCopyEmail}
                className="group flex items-center gap-3 text-brand-black transition-all hover:text-brand-blue"
              >
                <div className="relative">
                  {copied ? (
                    <Check className="h-5 w-5 text-green-600 transition-all duration-200 scale-110" />
                  ) : (
                    <Mail className="h-5 w-5 transition-all duration-200" />
                  )}
                </div>

                <div className="flex flex-col items-start">
                  <span className="text-sm font-medium">
                    {copied ? 'Copied to clipboard!' : 'Email Us'}
                  </span>
                  <span className="text-[10px] opacity-60 group-hover:opacity-100 transition-opacity">
                    {email}
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 border-t border-brand-black/10 pt-8 text-center">
          <p className="text-sm font-medium text-brand-black">
            © {new Date().getFullYear()} UNILinkd. All rights reserved.
          </p>
        </div>
      </div>

      {/* ✅ Toast Popup */}
      {showToast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-xl bg-brand-black px-4 py-2 text-xs font-medium text-white shadow-lg">
          Email copied to clipboard
        </div>
      )}
    </footer>
  );
}
